/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Latency_Weighted_P99Inputs */

const en_measure_latency_weighted_p99 = /** @type {(inputs: Measure_Latency_Weighted_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weighted p99 estimate`)
};

const zh_hans1_measure_latency_weighted_p99 = /** @type {(inputs: Measure_Latency_Weighted_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p99 加权估算`)
};

const pt_br2_measure_latency_weighted_p99 = /** @type {(inputs: Measure_Latency_Weighted_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimativa ponderada de p99`)
};

const es_measure_latency_weighted_p99 = /** @type {(inputs: Measure_Latency_Weighted_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimación ponderada de p99`)
};

const fr_measure_latency_weighted_p99 = /** @type {(inputs: Measure_Latency_Weighted_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimation p99 pondérée`)
};

const de_measure_latency_weighted_p99 = /** @type {(inputs: Measure_Latency_Weighted_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewichtete p99-Schätzung`)
};

const ru_measure_latency_weighted_p99 = /** @type {(inputs: Measure_Latency_Weighted_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Взвешенная оценка p99`)
};

const it_measure_latency_weighted_p99 = /** @type {(inputs: Measure_Latency_Weighted_P99Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima p99 ponderata`)
};

/**
* | output |
* | --- |
* | "Weighted p99 estimate" |
*
* @param {Measure_Latency_Weighted_P99Inputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_weighted_p99 = /** @type {((inputs?: Measure_Latency_Weighted_P99Inputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_Weighted_P99Inputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_weighted_p99(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_weighted_p99(inputs)
	if (locale === "es") return es_measure_latency_weighted_p99(inputs)
	if (locale === "fr") return fr_measure_latency_weighted_p99(inputs)
	if (locale === "de") return de_measure_latency_weighted_p99(inputs)
	if (locale === "ru") return ru_measure_latency_weighted_p99(inputs)
	if (locale === "it") return it_measure_latency_weighted_p99(inputs)
	return en_measure_latency_weighted_p99(inputs)
});